import { TFunction } from 'core/i18n/i18n';

export const getSaveFilterValidationMessages = (t: TFunction) => ({
    saveFilter: {
        error: {
            duplicated: t('commons.components.save-edit-filter-modal.name-already-exists'),
            'value-missing': t('commons.components.save-edit-filter-modal.empty-error'),
        },
    },
});
